export default "__VITE_ASSET__3d58554d__"